import AppAPI from '../../lib/api';


export const setBooking = (bookingData, propertyId) => (dispatch) => new Promise(async (resolve, reject) => {
  return AppAPI.bengineapi.get(`${propertyId}/booking/${bookingData}/`)
    .then((res) => {
      dispatch({
        type: 'SET_BOOKING',
        data: res
      });
      return resolve(res);
    })
    .catch(err => {
      dispatch({
        type: 'SET_BOOKING',
        data: {}
      });
      return reject(err);
    });
});

export const setTicketBooking = (eventData, propertyId) => (dispatch) => new Promise(async (resolve, reject) => {
  return AppAPI.bengineapi.get(`${propertyId}/ticket-booking/${eventData}/`)
    .then((res) => {
      dispatch({
        type: 'SET_TICKET_BOOKING',
        data: res
      });
      return resolve(res);
    })
    .catch(err => {
      dispatch({
        type: 'SET_TICKET_BOOKING',
        data: {}
      });
      return reject(err);
    });
});

